export default __webpack_public_path__ + "static/shadow-42373f30371745b42d52f4128738e4fe.webp";